import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery } from 'wasp/client/operations';
import { getSiteAccessStatus, verifySiteAccessPassword } from 'wasp/client/operations';
import { AuthPageLayout } from '../../auth/AuthPageLayout';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { grantSiteAccess, SITE_ACCESS_POST_GATE_PATH } from './siteAccess';
import { toast } from 'react-hot-toast';

export default function SiteAccessGatePage() {
  const navigate = useNavigate();
  const { data: status, isLoading: statusLoading } = useQuery(getSiteAccessStatus);
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!statusLoading && status && !status.enabled) {
      grantSiteAccess();
      navigate(SITE_ACCESS_POST_GATE_PATH, { replace: true });
    }
  }, [status, statusLoading, navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!password.trim()) {
      toast.error('Please enter the access password');
      return;
    }

    setSubmitting(true);
    try {
      await verifySiteAccessPassword({ password });
      grantSiteAccess();
      navigate(SITE_ACCESS_POST_GATE_PATH, { replace: true });
    } catch {
      toast.error('Incorrect password');
    } finally {
      setSubmitting(false);
    }
  };

  if (statusLoading || (status && !status.enabled)) {
    return null;
  }

  return (
    <AuthPageLayout>
      <div className="space-y-6">
        <div className="text-center space-y-2">
          <h1 className="text-2xl font-semibold tracking-tight text-gray-900">Site access</h1>
          <p className="text-sm text-muted-foreground">
            Enter the access password to continue.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="site-access-password">Password</Label>
            <Input
              id="site-access-password"
              type="password"
              autoComplete="current-password"
              autoFocus
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={submitting}
              placeholder="Access password"
            />
          </div>
          <Button type="submit" className="w-full" disabled={submitting}>
            {submitting ? 'Checking…' : 'Continue'}
          </Button>
        </form>
      </div>
    </AuthPageLayout>
  );
}
